var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckcircleWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check_circle",
    "data-name": "check circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.688,
    height: 32.688,
    viewBox: "0 0 32.688 32.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M16.988,31.954q-.282,0-.563-.011A14.982,14.982,0,1,1,23.078,3.285a1.362,1.362,0,1,1-1.107,2.489,12.256,12.256,0,1,0,7.268,11.2V15.725a1.362,1.362,0,1,1,2.724,0v1.253A14.983,14.983,0,0,1,16.988,31.954Z",
    transform: "translate(-0.638 -0.635)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M21.448,22.357a1.362,1.362,0,0,1-.963-.4L16.4,17.873a1.362,1.362,0,1,1,1.926-1.926l3.122,3.122L34.1,6.4a1.362,1.362,0,0,1,1.927,1.925L22.411,21.958a1.362,1.362,0,0,1-.963.4Z",
    transform: "translate(-5.104 -1.914)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M0,0H32.688V32.688H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckcircleWhite);
export default __webpack_public_path__ + "static/media/checkcircle_white.e9b4805cb6b407dcd837e51315e13aec.svg";
export { ForwardRef as ReactComponent };